import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import ReactCountryFlag from "react-country-flag";
import { getName } from "country-list";
import { setLspOnboarding, fetchLsps } from "./lspSlice";

const useLspLists = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isAuditSidebarOpen, setIsAuditSidebarOpen] = useState(false);
  const [allLsp, setAllLsp] = useState(null);
  const [selectedValues, setSelectedValues] = useState({});
  const [chipData, setChipData] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState({
    country: [],
    services: [],
  });
  const { lspList, searchLsp, lsplistpage, lsplistlimit } = useSelector(
    (state) => state.lsponboarding,
  );

  useEffect(() => {
    dispatch(fetchLsps());
  }, []);

  useEffect(() => {
    setAllLsp(lspList);
  }, [lspList]);

  const handleAddNewLsp = () => {
    navigate("/lsp/onboard");
  };

  const onLspPageChange = (event) => {
    dispatch(setLspOnboarding({ key: "lsplistpage", value: event.first }));
    dispatch(setLspOnboarding({ key: "lsplistlimit", value: event.rows }));
  };

  const servicesArray = (data) => {
    const uniqueServicesMap = new Map();
    data.forEach((item) => {
      item.access.forEach((access) => {
        access.services.forEach((service) => {
          if (!uniqueServicesMap.has(service.name)) {
            uniqueServicesMap.set(service.name, {
              code: service.id,
              name: service.name,
            });
          }
        });
      });
    });
    const uniqueServicesArray = Array.from(uniqueServicesMap.values());
    return uniqueServicesArray;
  };

  const handleSearchChange = (e) => {
    let search = e.target.value;
    dispatch(
      setLspOnboarding({
        key: "searchLsp",
        value: search,
      }),
    );
  };

  // const handleCountryFlag = (rowData) => {
  //   return (
  //     <div className="country-tag">
  //       <ReactCountryFlag countryCode={rowData.country} svg />
  //       <span style={{ textTransform: "capitalize", marginLeft: "7px" }}>
  //         {getName(rowData.country)}
  //       </span>
  //     </div>
  //   );
  // };

  const filterOptions = useMemo(() => {
    if (!lspList) return [];
    let countries;
    const countylist = lspList?.flatMap((record) =>
      record.access.map((accessItem) => accessItem.entity.country),
    );
    countries = Array.from(new Set(countylist));

    return [
      {
        name: "Country",
        id: "country",
        // suboptions: countries.map((country) => ({
        //   name: "",//handleCountryFlag({ country }),
        //   code: country,
        // })),
        suboptions: countries,
      },
      {
        name: "Services",
        id: "services",
        suboptions: servicesArray(lspList),
      },
    ];
  }, [lspList]);

  const normalize = (val) => {
    if (!val) return "";
    return String(val)?.toLowerCase();
  };
  const search = (lspData, searchTerm) => {
    const term = normalize(searchTerm);
    return lspData.filter((item) => {
      const mainFieldsMatch =
        normalize(item.name)?.includes(term) ||
        normalize(item.account_manager_name)?.includes(term);
      const countryMatch = item.access.some((access) => {
        const countryName = getName(access.entity.country) || "";
        return normalize(countryName)?.includes(term);
      });
      const serviceMatch = item.access.some((access) =>
        access.services.some((service) =>
          normalize(service.name)?.includes(term),
        ),
      );
      return mainFieldsMatch || countryMatch || serviceMatch;
    });
  };

  const handleChipData = (selectedValues) => {
    let chipArray = [];
    for (const key in selectedValues) {
      selectedValues[key].map((data) => {
        chipArray.push({ category: key, value: data });
      });
    }
    setChipData(chipArray);
  };

  const applyFilters = () => {
    if (lspList && lspList?.length > 0) {
      let filtered = [...lspList];
      if (selectedValues?.country?.length > 0) {
        let filterCountries = selectedValues?.country;
        filtered = filtered.filter((item) =>
          item.access.some((access) =>
            filterCountries.includes(access.entity.country),
          ),
        );
      }
      if (selectedValues?.services?.length > 0) {
        let filteredServiceIds = selectedValues?.services;
        filtered = filtered.filter((item) => {
          return item.access.some((access) => {
            return access.services.some((service) => {
              return filteredServiceIds?.includes(normalize(service?.id));
            });
          });
        });
      }
      if (searchLsp) {
        const searchTerm = normalize(searchLsp);
        filtered = search(filtered, searchTerm);
      }
      setAllLsp(filtered);
      handleChipData(selectedValues);
    }
  };
  const uniqueServices = useMemo(() => {
    if (!allLsp) return {};

    const seen = new Set();
    const result = {};

    for (const lsp of allLsp) {
      for (const access of lsp.access || []) {
        for (const service of access.services || []) {
          if (!seen.has(service.id)) {
            seen.add(service.id);
            result[service.id] = service.name;
          }
        }
      }
    }

    return result;
  }, [allLsp]);

  const handleRemoveFilter = (data) => {
    const updatedArray = selectedValues[data.category].filter(
      (value) => value !== data.value,
    );
    delete selectedFilters[data?.value];

    const filteredValue = {
      ...selectedValues,
      [data.category]: updatedArray,
    };

    setSelectedValues(filteredValue);

    setSelectedFilters((prev) => ({
      ...prev,
      [data.category]: updatedArray,
    }));

    handleChipData(filteredValue);

    if (lspList?.length > 0) {
      let filtered = [...lspList];

      if (filteredValue.country?.length > 0) {
        filtered = filtered.filter((item) =>
          item.access.some((access) =>
            filteredValue.country.includes(access.entity.country),
          ),
        );
      }

      if (filteredValue.services?.length > 0) {
        const filteredServiceIds = filteredValue.services;
        filtered = filtered.filter((item) =>
          item.access.some((access) =>
            access.services.some((service) =>
              filteredServiceIds?.includes(normalize(service?.id)),
            ),
          ),
        );
      }

      if (searchLsp) {
        const searchTerm = normalize(searchLsp);
        filtered = search(filtered, searchTerm);
      }

      setAllLsp(filtered);
    }
  };
  const deSelectAll = () => {
    setSelectedFilters({
      country: [],
      services: [],
    });
    let lstData = lspList;
    if (searchLsp) {
      const searchTerm = normalize(searchLsp);
      lstData = search(lspList, searchTerm);
    }
    setAllLsp(lstData);
    setSelectedValues({});
    setChipData([]);
  };
  useEffect(() => {
    applyFilters();
  }, [searchLsp]);

  return {
    statevalues: {
      allLsp,
      lsplistpage,
      lsplistlimit,
      searchLsp,
      selectedFilters,
      isAuditSidebarOpen,
    },
    handleAddNewLsp,
    onLspPageChange,
    handleSearchChange,
    filterOptions,
    setSelectedFilters,
    setIsAuditSidebarOpen,
    applyFilters,
    deSelectAll,
    selectedValues,
    setSelectedValues,
    chipData,
    setChipData,
    handleRemoveFilter,
    uniqueServices,
  };
};

export default useLspLists;
